import React, { useState,useEffect } from "react";
import { Box, DataTable, Button } from "grommet";
import {withRouter} from 'react-router-dom'
import { CSVLink } from "react-csv";
import { CloudDownload } from "grommet-icons";
import {BillingTableColumns} from './utils/shared/shipmentViewFunctions'
import { TableLoadLayer } from "./utils/shared/shared";



function BillingTable(props) {
    const[tablePageNumber, setTablePageNumber] = useState(parseInt(props.props.location.search.slice(6)))
    const [startIndex, setStartIndex] = useState((props.props.location.state ? props.props.location.state.startIndex: 0))
    const [endIndex, setEndIndex]=useState((props.props.location.state ? props.props.location.state.endIndex: 10))
    const[currentData, setCurrentData]=useState(props.shipments.slice((props.props.location.state ? props.props.location.state.startIndex: 0),(props.props.location.state ? props.props.location.state.endIndex: 10)))
    const [clickableRow, setClickabelRow] = useState(true)
    const [reshipShipment, setReshipShipment] = useState()
    useEffect(() => {
      if (props.props.location.search){
        var page = parseInt(props.props.location.search.slice(6))
        onPageChange((props.props.location.state ? props.props.location.state.startIndex: 0),(props.props.location.state ? props.props.location.state.endIndex: 10),page)
      } else {
        onPageChange(0,10,1)
      }
    },[])
    function onPageChange(startIndex, endIndex, page){
      const nextData = props.shipments.slice(startIndex, endIndex);
      setTablePageNumber(page)
      setStartIndex(startIndex)
      setEndIndex(endIndex)
      setCurrentData(nextData)
      props.props.history.push({search: `?page=${page}`})
    }
    let columns = BillingTableColumns(props.shipments,props.displayQuote,props.checked,props,setClickabelRow,reshipShipment)
    return (
      <DataTable   
        paginate={{
          onChange: ({page, startIndex, endIndex}) => {onPageChange(startIndex, endIndex, page)},
          numberItems: props.shipments.length,
          data: currentData,
          page: tablePageNumber,
          show:{page:tablePageNumber}
        }}
        margin={{body:'xsmall'}}
        background={{
          header: { color: '#18445C'},
          footer: { color: 'dark-3', opacity: 'strong' },
        }}
        pad={{body: 'small', header:'small', cell:'xxsmall'}}
        step={10}
        columns={columns}
        // rowDetails={(row) => {
        // return <Box direction="row"><Text>User: {row.user}</Text><Button onClick={() => { props.props.history.push({pathname:`/shipment/${row.id}`, shipment: row, state:{page: tablePageNumber, startIndex: startIndex, endIndex: endIndex}})}} /></Box>
        //         }}
        data={props.shipments}
        onClickRow={({datum}) => {
          if (props.checked){
            return
          } else {
            if (clickableRow){
              props.props.history.push({pathname:`/admin/billing/shipment/${datum.id}`, shipment: datum, state:{page: tablePageNumber, startIndex: startIndex, endIndex: endIndex}})
            } else {
              setReshipShipment(datum)
              return
            }}}}
      />
    );
  }

function ShipmentBillingTable(props){
  const headers = [{ label: "ID", key: "id" },{ label: "Origin Country", key: "origin.country.CountryName" },{ label: "Destination Country", key: "destination.country.CountryName" },{ label: "User", key: 'user'},{label: 'Account', key:"details.name"},{ label: "AWB Number", key: "awb_number" },{ label: "Status", key: "status" },{ label: "Pieces", key: "pieces.TotalPieces"},{ label: "Actual Weight (KG)", key: "quote.total_actual_weight"},{ label: "Billable Weight", key: "quote.quoted_weight"},{ label: "Quote (USD)", key: "quote.total_quote_price"},{ label: "Purchase Order Reference", key: "pieces.CustomerPO" }]
  if (props.props.props.user === 'SuperAdmin' && props.dataLoaded){
    return (
        <Box margin='small'> 
          <Box elevation="medium" overflow='scroll' round  margin='small'>
            <BillingTable props={props.props} shipments={props.shipments} displayQuote={props.displayQuote} />
          </Box>
          <CSVLink data={props.shipments} headers={headers} target='_blank'><Button margin='medium' primary size='small' label="Download Data" icon={<CloudDownload size='small'/>} /></CSVLink>
        </Box>
    )
  } else {
    return (
        <Box margin='small'>
        <Box direction="row" justify="between"><Box direction="row"></Box></Box> 
        <Box elevation="medium" overflow='scroll' round margin='small'>
          <TableLoadLayer load={true} label={"Loading Shipments..."} />
        </Box>
      </Box>
    )
  }
    
}

export default withRouter(ShipmentBillingTable);
